import { MenuWrapper, MenuWrapperAttributes } from 'components/Shared/Form/InputSelect/menuWrapper';
import { InputOptionProps, Option } from 'components/Shared/Form/InputSelect/option';
import { Input, InputProps } from 'components/Shared/Form/input';
import { LoadingOption } from 'components/Shared/Form/InputSelect/loadingOption';
import { ComponentType } from 'react';

export interface SelectComponents {
  MenuWrapper: ComponentType<MenuWrapperAttributes>;
  LoadingOption: ComponentType;
  Option: ComponentType<InputOptionProps>;
  Input: ComponentType<HTMLInputElement | InputProps>;
}
export const defaultComponents = ({
  components
}: {
  components?: SelectComponents;
}): SelectComponents => ({
  MenuWrapper,
  LoadingOption,
  Option,
  Input,
  ...components
});
